import { COMPANY_DNS } from './company.constants'

/**
 * The tenant's servicing mailbox, copied on document emails sent from a loan. It comes from
 * Admin > Configuration > Email Setup (SERVICE_EMAIL) via appInit, because the address a tenant
 * reads is theirs to choose: Longhorn's is `LS@longhorninvestments.com`, and the composed
 * `servicing@<company dns>` below is only a fallback for a tenant that has configured none.
 */
let configuredServiceEmail = ''

export const setServiceEmail = (value?: string | null) => {
  configuredServiceEmail = typeof value === 'string' ? value.trim() : ''
}

export const servicingEmail = () => configuredServiceEmail || `servicing@${COMPANY_DNS}`
